import risikaAPI from 'services/api/helpers/risikaAPI'

/******************
 * Fetch from API *
 ******************/

const zipcodeList = (country) => {
  return risikaAPI
    .get(`/list/zipcodes`, {
      microservice: 'data',
      country,
    })
    .then(({ data }) => {
      return data.zipcodes
    })
}

export default zipcodeList
